import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { equals } from 'ramda';


export const createKeyMatchSelector = createSelectorCreator(defaultMemoize, (a,b) => a === undefined || b === undefined || equals(Object.keys(a), Object.keys(b)));